import {BridgeMessage} from "js-vextensions";
import {observer_mgl, RunInAction} from "mobx-graphlink";
import React from "react";
import {Button, Row, Text} from "react-vcomponents";
import {remoteUserProcessesBridge} from "../../../../Utils/Bridge/Bridge_RemoteUserProcesses.js";
import {OnPopulated} from "web-vcore";
import {store} from "../../../../Store/index.js";

let remoteUserProcessesBridge_lastReceivedFunctionCall_info: {msg: BridgeMessage, time: number}|n;
let remoteUserProcessesBridge_lastReceivedCallback_info: {msg: BridgeMessage, time: number}|n;
OnPopulated(()=>{
	const remoteUserProcessesBridge_OnReceiveFunctionCall_old = remoteUserProcessesBridge.OnReceiveFunctionCall;
	remoteUserProcessesBridge.OnReceiveFunctionCall = function(msg: BridgeMessage) {
		remoteUserProcessesBridge_lastReceivedFunctionCall_info = {msg, time: Date.now()};
		RunInAction("BridgesTab.bridge1.OnReceiveFunctionCall", ()=>store.main.testing.lastBridgeMessages_changedAt = Date.now());
		return remoteUserProcessesBridge_OnReceiveFunctionCall_old.call(this, msg);
	};
	const remoteUserProcessesBridge_OnReceiveCallback_old = remoteUserProcessesBridge.OnReceiveCallback;
	remoteUserProcessesBridge.OnReceiveCallback = function(msg: BridgeMessage) {
		remoteUserProcessesBridge_lastReceivedCallback_info = {msg, time: Date.now()};
		RunInAction("BridgesTab.bridge1.OnReceiveCallback", ()=>store.main.testing.lastBridgeMessages_changedAt = Date.now());
		return remoteUserProcessesBridge_OnReceiveCallback_old.call(this, msg);
	};
});

export const BridgesTab = observer_mgl(()=>{
	const uiState = store.main.testing;
	uiState.lastBridgeMessages_changedAt; // eslint-disable-line

	const info1 = remoteUserProcessesBridge_lastReceivedFunctionCall_info;
	const info2 = remoteUserProcessesBridge_lastReceivedCallback_info;

	return (
		<>
			<Row mt={5}>
				<Text>Last function-call: ({info1 ? new Date(info1?.time).toLocaleString("sv") : "n/a"})</Text>
				<Button ml="auto" text="Clear" onClick={()=>{
					remoteUserProcessesBridge_lastReceivedFunctionCall_info = null;
					uiState.lastBridgeMessages_changedAt = Date.now();
				}}/>
			</Row>
			<Text mt={5} sel style={{flex: 50, whiteSpace: "pre-wrap"}}>{
				JSON.stringify(info1?.msg ?? "n/a", null, "\t")
			}</Text>
			<Row mt={5}>
				<Text>Last callback: ({info2 ? new Date(info2?.time).toLocaleString("sv") : "n/a"})</Text>
				<Button ml="auto" text="Clear" onClick={()=>{
					remoteUserProcessesBridge_lastReceivedCallback_info = null;
					uiState.lastBridgeMessages_changedAt = Date.now();
				}}/>
			</Row>
			<Text mt={5} sel style={{flex: 50, whiteSpace: "pre-wrap"}}>{
				JSON.stringify(info2?.msg ?? "n/a", null, "\t")
			}</Text>
		</>
	);
});